import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterModule } from '@angular/router';
import { FloatingDialogService } from '../../../services/floating-dialog.service';
import { MatterDetailsComponent } from '../../matters/matter-details.component';
import { MatterCellComponent } from '../matter-cell/matter-cell.component';

export interface MattersListDialogMatter {
  clientMatterNumber: string;
  clientName?: string;
  matterName?: string;
  /** Full names of resources assigned to this matter. */
  resources?: string[];
}

export interface MattersListDialogData {
  requestId?: number;
  matters: MattersListDialogMatter[];
}

@Component({
  selector: 'app-matters-list-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    RouterModule,
    MatterCellComponent,
  ],
  templateUrl: './matters-list-dialog.component.html',
  styleUrls: ['./matters-list-dialog.component.scss'],
})
export class MattersListDialogComponent {
  dialogRef = inject<MatDialogRef<MattersListDialogComponent>>(MatDialogRef);
  data = inject<MattersListDialogData>(MAT_DIALOG_DATA);
  private router = inject(Router);
  private floatingDialogService = inject(FloatingDialogService);

  /** Tracks which matter rows have their resources section expanded. All collapsed by default. */
  expandedMatters = new Set<string>();

  toggleResources(clientMatterNumber: string): void {
    if (this.expandedMatters.has(clientMatterNumber)) {
      this.expandedMatters.delete(clientMatterNumber);
    } else {
      this.expandedMatters.add(clientMatterNumber);
    }
  }

  navigateToMatter(clientMatterNumber: string): void {
    this.close();
    this.router.navigate(['/matters', clientMatterNumber]);
  }

  openMatterInFloatingDialog(matter: MattersListDialogMatter): void {
    this.floatingDialogService.open(
      MatterDetailsComponent,
      matter.matterName ?? matter.clientMatterNumber,
      { clientMatterNumber: matter.clientMatterNumber },
    );
  }

  close(): void {
    this.dialogRef.close();
  }
}
